var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{staticClass:"page__forbidden",attrs:{"title":"Dostęp zabroniony"}})}
var staticRenderFns = []

export { render, staticRenderFns }